import { Injectable, signal } from '@angular/core';
import { GroupedEntries } from '../../models/yarn-requisition/yarn-requisition-form';

export interface RequisitionFabric {
  fabricCode: string;
  totalQuantity: number;
  yarnDetails: {
    yarnCode: string;
    usePercentage: number;
    quantity: number;
  }[];
}

@Injectable()
export class InventoryRequisitionService {
  public groupedEntries = signal<GroupedEntries[]>([]);
  private selectedFabrics = signal<RequisitionFabric[]>([]);
  readonly selectedFabrics$ = this.selectedFabrics.asReadonly();

  public calcRequiredItems(value: string, index: number) {
    const numberValue = Number(value);
    this.selectedFabrics.update((arr) => {
      const newSelectedFabrics = [...arr];

      newSelectedFabrics[index] = {
        ...newSelectedFabrics[index],
        totalQuantity: numberValue,
        yarnDetails: newSelectedFabrics[index].yarnDetails.map((yarn, yarnIndex) => {
          this.groupedEntries()[index].entries.controls[yarnIndex].patchValue({
            requiredQuantityInUnitOfMeasure: (yarn.usePercentage / 100) * numberValue,
          });
          return {
            ...yarn,
            quantity: (yarn.usePercentage / 100) * numberValue,
          };
        }),
      };
      return newSelectedFabrics;
    });
  }
}
